import React from 'react';
import { useDispatch } from 'react-redux';
import * as ModalActions from '../../../stores/actions/modal';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';

export default function BroadcastFailed(): JSX.Element {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<MultiButtonConfirmationModal
			className='broadcast-failed'
			headerText='Broadcast Failed'
			secondButtonText='Close'
			secondButtonAction={closeModal}
			isOpen
		>
			<span>
				The broadcast has failed to start. Please double check the RTMP address
				and stream keys to ensure there are no typos. This is the most common reason for failure.
			</span>
			<span>If you believe there is an issue, please call or email 24/7 support:</span>
			<span>
				<span className='font-weight-bold' style={ { display: 'inline' } }>Submit a ticket: </span>
				<a href="https://support.brandlive.com/hc/en-us/requests/new" target="_blank">https://support.brandlive.com/hc/en-us/requests/new</a>
			</span>
			<span>
				<span className="font-weight-bold" style={{ display: 'inline' }}>
					US Toll Free:
				</span>{' '}
				<a href="tel:+18664550897">+1 866 455 0897</a> or{' '}
				<a href="https://support.brandlive.com/hc/en-us/articles/360048964331" target="_blank">
					Click Here
				</a>{' '}
				for global numbers.
			</span>
			<span><a href="mailto:Streamingemergency@brandlive.com">Streamingemergency@brandlive.com</a></span>
		</MultiButtonConfirmationModal>
	);
}
